<template>
  <div class="w-100 d-flex align-items-top invoice-item">
    <b-skeleton width="35px" height="35px" type="avatar"></b-skeleton>
    <div class="ml-auto pl-3 flex-grow-1">
      <b-skeleton animation="fade" width="100%"></b-skeleton>
      <b-skeleton animation="fade" width="100%"></b-skeleton>
      <b-skeleton animation="fade" width="35%"></b-skeleton>
    </div>
  </div>
</template>
<script>


export default {
  name: 'InvoiceItemSkeleton',
};
</script>



// WEBPACK FOOTER //
// src/portal-components/invoice/invoice-item-skeleton.vue